export default "__VITE_ASSET__CN9CXxX9__"